const month = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember'
]
const shortMonth = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mei',
  'Jun',
  'Jul',
  'Agu',
  'Sep',
  'Okt',
  'Nov',
  'Des'
]
export default {
  methods: {
    convertDate (date) {
      if (!date) return '-'
      const splitedDate = date.split('-')

      return `${splitedDate[2]} ${month[splitedDate[1] - 1]} ${splitedDate[0]}`
    },
    convertDateNotification (date) {
      if (!date) return '-'
      const splitedDate = date.split(' ')[0].split('-')

      return `${splitedDate[2]} ${month[splitedDate[1] - 1]} ${splitedDate[0]}`
    },
    logger (msg) {
      // eslint-disable-next-line no-console
      return process.env.NODE_ENV === 'production' ? msg : console.log(msg)
    },
    monthName (date) {
      return month[date.getMonth()]
    },
    shortMonthName (date) {
      return shortMonth[date.getMonth()]
    },
    convertDateUTC (date) {
      if (!date) return '-'
      const splitedDate = date.split('T')[0]

      return this.convertDate(splitedDate)
    }
  },
  computed: {
    isMobileScreen () {
      return window.screen.width < 391
    }
  }
}
